import React from 'react';
import './EditAgencyPopup.css';
import Popup from '../../components/popup/Popup';
import FormTemplate from '../../components/templates/formTemplates/FormTemplate';
import Card from '../../components/card/Card';
import Label from '../../components/label/Label';
import Input from '../../inputs/input/Input';
import Button from '../../components/button/Button';
import objUtils from '../../utils/objUtils';

export default class EditAgencyPopup extends FormTemplate {
	constructor() {
		super();
		this.state = {
			isValid: true
		};
	}
	validateAndSave = () => {
		let value = this.getValue();
		if (objUtils.isEmpty(value) || value.name.length < 1) return this.setState({ isValid: false });
		this.props.onComplete(value);
		this.props.onClose();
	};

	getClassNames = () => {
		let classNames = ['g-agency-edit-popup'];
		if (!this.state.isValid) classNames.push('invalid');
		return classNames.join(' ');
	};

	render() {
		let show = this.props.show;
		if (!this.props.hasOwnProperty('show')) {
			show = true;
		}
		return (
			<Popup {...this.props} show={show} className={this.getClassNames()}>
				<Card>
					<Label large black>
						{this.props.title}
					</Label>
					<Input ref={(ref) => (this.myRefs.name = ref)} placeholder={this.props.namePlaceholder} required />
					<div className="actions">
						<Button color="blue" bg="white" onClick={this.props.onClose}>
							No
						</Button>
						<Button color="white" bg="blue" onClick={this.validateAndSave}>
							Yes
						</Button>
					</div>
				</Card>
			</Popup>
		);
	}
}



// WEBPACK FOOTER //
// ./src/popups/editAgencyPopup/EditAgencyPopup.jsx